import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Пока вход определяется, поверх висит заставка из index.html — второй
  // загрузчик только мигал бы. Поэтому здесь ничего не рисуем.
  if (isLoading) return null;

  // Куда человек шёл — запоминаем, чтобы вернуть после входа.
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
